var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeftLightSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 20",
    width: 13,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-left-dark-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13 19.5h-12.31v-19.39h12.31z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #ffffff } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Layer_1",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "s0",
    d: "m3.2 12.8c1.1 1.1 3.8 3.7 6.5 6.2l0.2 0.2 0.3 0.2c0.3 0.2 0.5 0.1 0.8-0.1 0.5-0.4 0.5-0.3 0.8-0.9 0.2-0.2 0.2-0.5 0.2-0.8-0.1-0.2-0.1-0.3-0.3-0.5-0.2-0.2-2.4-2.4-6.3-6.6 0 0-2-2.2 0.1-3.5 3.6-2.1 5.6-2.7 7.1-3.5 0.3-0.1 0.4-0.3 0.4-0.4 0-0.2 0-0.5-0.1-0.8-0.2-0.8-0.8-1.2-1.3-1.8-0.3-0.3-0.4-0.5-0.9-0.3-2.2 1.3-7.1 3.8-7.9 4.3-3.6 2-1.9 6.1 0.4 8.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLightSvg);
export default __webpack_public_path__ + "static/media/arrow-left-light-svg.8c08de3f44f3e62d89d34ada54597614.svg";
export { ForwardRef as ReactComponent };